module.exports = [
    {
        value: 'shipper',
        name: 'Shipper',
    },
    {
        value: 'carrier',
        name: 'Carrier',
    },
];
